.card {
  width: 100%;
  margin: 0 auto;
  padding: 24px 0;
  border-radius: 32px;
  background: #ece7dd;
  box-sizing: border-box;
}

.title {
  font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
  margin: 0 0 24px;
  padding: 0 20px;
  text-align: center;
  color: #221E1A;
  font-size: 19px;
  font-weight: 700;
  line-height: 24px;
  letter-spacing: 0.076px;
}

.imageBox {
  position: relative;
  width: 100%;
  aspect-ratio: 665 / 342;
  max-width: 335px;
  margin: 0 auto;
}

.image {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
  user-select: none;
  pointer-events: none;
}

.label {
  position: absolute;
  z-index: 1;
  color: #7A7670;
  font-size: 12px;
  font-weight: 400;
  line-height: 14px;
  letter-spacing: 0.048px;
  white-space: nowrap;
  pointer-events: none;
}

.labelCurrent {
  left: 1.8%;
  top: 73.2%;
  transform: rotate(-78deg);
  transform-origin: center;
}

.labelFirst {
  left: 27.8%;
  top: 11.5%;
  transform: rotate(-20deg);
  transform-origin: center;
}

.labelSecond {
  left: 58.6%;
  top: 14.2%;
  transform: rotate(25deg);
  transform-origin: center;
}

.labelThird {
  right: 5.4%;
  top: 55.2%;
  transform: rotate(72deg);
  transform-origin: center;
}

.labelCenter {
  left: 50%;
  bottom: 8.8%;
  transform: translateX(-50%);
  font-size: clamp(12px, 3vw, 15px);
  font-weight: 600;
  text-align: center;
  font-family: var(--ed-font-rounded, ui-rounded, "SF Pro Rounded", Nunito, "SF Pro Text", -apple-system, BlinkMacSystemFont, "Roboto", sans-serif);
  font-weight: 600;
}

.legend {
  margin-top: 14px;
  display: flex;
  justify-content: center;
  gap: 26px;
  flex-wrap: wrap;
}

.legendItem {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #221E1A;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.036px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  flex: 0 0 auto;
}

.dotTraining {
  background: linear-gradient(90deg, #C7D239 0%, #2AA174 100%);
}

.dotResults {
  background: linear-gradient(90deg, #F0B70C 0%, #F0930C 100%);
}